export default __webpack_public_path__ + "locales/es/PreparationPortal.json?hash=f4e8bd49894968490ceacdb2c9a239f4";